module.exports = __webpack_public_path__ + "img/Z61_05.c3b4db66.jpg";